import { useFormik } from 'formik';
import React, {  useContext, useState } from 'react'
import { AiFillEdit } from 'react-icons/ai';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import PasswordFiled from '../../Form/PasswordField';
import { passwordValidation, passwordValidationsignup } from '../../../utils/validation';
import * as yup from 'yup';
import { changePasswordService } from '../../../services/authServices';
import errorModel from '../../Errors/ErrorModel';
import { rootContexts } from '../../../contexts/rootContexts';
export default function SecuritySection() {
    const [asPresonalInfoEdit, setAsPersonalInfoEdit] = useState(false);
    const {asLoading}= useContext(rootContexts);

    const formik = useFormik({
      initialValues: {
   
        current_password:"",
        password:"",
        password_confirmation:"",
      },
      validationSchema: yup.object({
        
        current_password:passwordValidation,
        password:passwordValidationsignup,
       
        password_confirmation:yup.string()
    .oneOf([yup.ref('password'), null], `Your new password cannot
    match your current password. Please enter a different password.`)
    .required('Please confirm your password')
        
      }),
      onSubmit:async(values)=>{
        console.log(localStorage.getItem("token"), "token12")
        const changePassword =await changePasswordService(values);
        console.log("theprofile data",changePassword);
        if(changePassword.status ===true){
          setAsPersonalInfoEdit(false)
          errorModel('success',changePassword.message)
        }
        else{
          errorModel('error',changePassword.message)
            
        }
      }
    });
   

  return (
    <>
      <div className="flex items-center pt-10 justify-between">
          <h1 className="h2">Security</h1>
        </div>
        {asLoading ? <Skeleton className='h-[200px] ' duration={1.5} />:
        <div className="mt-2 border-2 border-beta p-4 rounded-md">
        <form id="secform"  onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-4 justify-center  gap-x-3 ">
            <div className='my-2'>
            <PasswordFiled
                label="Current Password"
                name="current_password"
                placeholder="Current Password"
                formik={formik}
                disabled={!asPresonalInfoEdit}
              />
            </div>
            <div className='my-8 sm:my-8 md:my-3 lg:my-2'>
            <PasswordFiled
                label="New Password"
                name="password"
                placeholder="Password"
                formik={formik}
                disabled={!asPresonalInfoEdit}
              />
            </div>
            <div className='my-8 sm:my-8 md:my-3 lg:my-2'>
              <PasswordFiled
                label="Confirm Password"
                name="password_confirmation"
                placeholder="Confirm Password"
                formik={formik}
                disabled={!asPresonalInfoEdit}
              />
            </div>
            <div className="mt-9 pl-6">
            <div>
            {asPresonalInfoEdit ? (
              <div className="flex items-center gap-x-3">
                <button className="btn-danger-outline !text-[12px]"  onClick={()=>setAsPersonalInfoEdit(!asPresonalInfoEdit)}>Cancel</button>
                <button type="submit" id="secform"  className="btn-sucess !text-[12px]">Save</button>
              </div>
            ) : (
              <button className="btn-primary  !text-[12px]" onClick={()=>setAsPersonalInfoEdit(!asPresonalInfoEdit)}>
                <AiFillEdit />
                Change Password
              </button>
            )}
          </div>
            </div>
            
          </div>
          </form>
        </div>
}
    </>
  )
}
